// material ui
import { Slider } from '@mui/material';

import styled from '@emotion/styled';

const InvertedSlider = styled(Slider, {
  shouldForwardProp: (prop) => prop !== 'isInverted',
})(({ theme, isInverted }) => ({
  color: '#4CAF50',
  height: 4,
  padding: '13px 0',
  '& .MuiSlider-thumb': {
    height: 28,
    width: 28,
    backgroundColor: '#fff',
    border: '1px solid #4CAF50',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 500,
    color: '#333',
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
    },
  },
  '& .MuiSlider-track': {
    height: 3,
    backgroundColor: isInverted ? '#d8d8d8' : '#4CAF50',
    borderRadius: 2,
    border: 'none',
  },
  '& .MuiSlider-rail': {
    height: 4,
    backgroundColor: isInverted ? '#4CAF50' : '#d8d8d8',
    opacity: 1,
    borderRadius: 2,
  },
  '& .MuiSlider-mark': {
    backgroundColor: '#888',
    height: 8,
    width: 2,
  },
  '& .MuiSlider-markActive': {
    backgroundColor: (theme) =>
      theme.palette.mode === 'light' ? 'gray' : 'lightgray',
  },
  '& .MuiSlider-valueLabel': {
    fontSize: 12,
    fontWeight: 'normal',
    top: -6,
    backgroundColor: 'unset',
    color: theme.palette.text.primary,
    '&::before': {
      display: 'none',
    },
    '& *': {
      background: 'transparent',
      color: '#000',
      ...theme.applyStyles('dark', {
        color: '#fff',
      }),
    },
  },
}));

export default InvertedSlider;
